import React, { Component } from 'react'
import AgeList from './AgeList'
import ReactDOM from 'react-dom'
import Quiz from './Quiz'

export class FourthScreen extends Component {
    state = {
        link: undefined
    }

    handleChangeForced = (input, e) => {
        this.setState({ [input]: e })
    }

    goTo = () => {
        ReactDOM.render(<Quiz link={this.state.link} />, document.getElementById('root'))
    }
    render() {
        return (
            <div>
                <div className="m-body">
                    <img className="m-headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                    <span className="m-home-text">Choose your Child's Age<br />and Begin Test</span>
                    <AgeList
                        goTo={this.goTo}
                        handleChangeForced={this.handleChangeForced}
                    />
                </div>
                <div className="bottom-part">
                    <img alt="snake-small" className="m-white-snake2 addGrey" src={require("../../assets/imgs/mobile/snake.png")} />
                    <div className="m-bullet-list">
                        <div className="m-bullet"></div>
                        <div className="m-bullet"></div>
                        <div className="m-bullet"></div>
                        <div className="m-bullet selected-bullet">
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FourthScreen
